import candidateContract from '@pages/candidate-contract/i18n/ru/candidate-contract.dic.json';

import bankDetailsDictionary from '@widgets/candidate-bank-details/i18n/ru/candidate-bank-details.dic.json';
import contractSignDictionary from '@widgets/candidate-contract-sign/i18n/ru/candidate-contract-sign.dic.json';
import officeDictionary from '@widgets/candidate-office/i18n/ru/candidate-office.dic.json';
import personalDataDictionary from '@widgets/candidate-personal-data/i18n/ru/candidate-personal-data.dic.json';

export const candiateContract = {
  CANDIDATE_CONTRACT: candidateContract,
  CANDIDATE_PERSONAL_DATA: personalDataDictionary,
  CANDIDATE_BANK_DETAILS: bankDetailsDictionary,
  CANDIDATE_CONTRACT_SIGN: contractSignDictionary,
  CANDIDATE_OFFICE: officeDictionary,
};

export const candiateContractNamespaces = Object.keys(candiateContract);
